import Button from '@atlaskit/button';

export * from '@atlaskit/button';
export type { ButtonProps } from '@atlaskit/button';
export default Button;
